import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import useWindowSize from './utils/useWindowSize'
import dateAlignModes from './utils/dateAlignModes';
import dateModes from './utils/dateModes';

import GanttHeader from './GanttHeader';
import GanttBody from './GanttBody';
import GanttControls from './GanttControls';

import './Gantt.css';

const Gantt = ({
  onBarsDragged,
  onBarsClicked,
  onBackClicked,
  onForwardClicked,
  hasSizeControls = true,
  areBarsDraggable = true,
  dateAlignMode = dateAlignModes.Left,
  colSize = 38,
  arrowBodyStyle,
  arrowBodyDashArray,
  arrowHeadStyle,
  arrowHeadDashArray,
  barData = [],
  setBarData,
  onBarClick,
  onBarMove,
  ...props
}) => {
  const [colCount, setColCount] = useState(0);
  const [colOffset, setColOffset] = useState(0);
  const [dateMode, setDateMode] = useState(dateModes.ByWeek); 

  const ref = useRef();
  const [windowWidth, windowHeight] = useWindowSize();
  
  const isFn = (obj) => (typeof obj === "function");

  console.log('gantt props', props);
  
  useEffect(() => {
    setColCount(Math.ceil(ref.current.clientWidth / colSize));
  }, [windowWidth, windowHeight, colSize]);
  
  const onBackClickedComposite = () => {
    setColOffset(prev => prev -= (colCount / 2));
  
    isFn(onBackClicked) && onBackClicked();
  };
  const onFwdClickedComposite = () => {
    setColOffset(prev => prev += (colCount / 2));
  
    isFn(onForwardClicked) && onForwardClicked();
  };
  const onDayModeClick = () => setDateMode(dateModes.ByDay);
  const onWeekModeClick = () => setDateMode(dateModes.ByWeek);
  const onMonthModeClick = () => setDateMode(dateModes.ByMonth);
  
  useEffect(() => console.log(dateMode), [dateMode]);
  
  return (
    <div style={{
        margin: 'auto', 
        width: '80%', 
        overflow: 'hidden',
      }} 
      className="gantt"
      {...props}
      ref={ref}
    >
      <svg
        height={colSize * (barData.length + 2)}
        width={colSize * colCount}
      >
        <GanttHeader 
          dateMode={dateMode}
          dateAlignMode={dateAlignMode}
          colSize={colSize}
          colCount={colCount} 
          colOffset={colOffset}
        />
        <GanttBody
          onBarsDragged={onBarsDragged}
          onBarsClicked={onBarsClicked}
          onBackClickedComposite={onBackClickedComposite}
          onFwdClickedComposite={onFwdClickedComposite}
          hasSizeControls={hasSizeControls}
          areBarsDraggable={areBarsDraggable}
          dateMode={dateMode}
          colSize={colSize} 
          colCount={colCount} 
          colOffset={colOffset}
          barData={barData}
          setBarData={setBarData}
          onBarClick={onBarClick}
          onBarMove={onBarMove}
        />
      </svg>
      <GanttControls 
        onBackClickedComposite={onBackClickedComposite}
        onFwdClickedComposite={onFwdClickedComposite}
        onDayModeClick={onDayModeClick}
        onWeekModeClick={onWeekModeClick}
        onMonthModeClick={onMonthModeClick}
      />
    </div>
  );
};

export default Gantt;
